<mat-icon
  [class]="{
    'material-icons-outlined': indicatorState === IndicatorState.INITIAL,
    initial: indicatorState === IndicatorState.INITIAL,
    alert: indicatorState === IndicatorState.ALERT,
    success: indicatorState === IndicatorState.SUCCESS,
    error: indicatorState === IndicatorState.ERROR,
    indicator: true
  }">
  check_circle
</mat-icon>
